﻿import {fetchFile, makeApiCall} from "./client";
import type {Project} from "../types/project.type";
import type {MeasurementSettingsRequest} from "../types/requests/measurement-settings-request.type";
import type {ProjectMapRequest} from "../models/project-map-request.model";

export async function postNewProject(name: string): Promise<string> {
    return await makeApiCall(
        `api/projects/`, 'POST', {Name: name}
    );
}

export async function updateProjectName(id: string, name: string) {
    return await makeApiCall(
        `api/projects/${id}`, 'PUT', {Name: name}
    );
}

export async function deleteProject(id: string) {
    return await makeApiCall(
        `api/projects/${id}`, 'DELETE'
    );
}

export async function getProjects(): Promise<Project[]> {
    return await makeApiCall(
        `odata/Projects?$orderby=Name asc`
    );
}

export async function getProjectExpanded(id: string): Promise<Project> {
    const [
        project,
        routes,
        gates,
        flowGates,
        trafficSegments
    ] = await Promise.all([
        makeApiCall(`odata/Projects(${id})`),
        makeApiCall(`odata/Routes?$filter=ProjectId eq ${id}&$expand=RouteGates,Sections`),
        makeApiCall(`odata/Gates?$filter=ProjectId eq ${id}`),
        makeApiCall(`odata/FlowGates?$filter=ProjectId eq ${id}&$expand=FlowMeasurementSite`),
        makeApiCall(`odata/TrafficSegments?$filter=ProjectId eq ${id}`)
    ]);

    return {
        ...project[0],
        routes,
        gates,
        flowGates,
        trafficSegments
    };
}

export async function updateProjectMeasurementSettings(settings: MeasurementSettingsRequest) {
    return await makeApiCall(
        `api/projects/${settings.projectId}/measurement-settings`, 'PUT', settings
    );
}

export async function getProjectFlowMeasurementsExport(id: string) {
    return await fetchFile(`api/projects/${id}/export-flow-measurements`);
}

export async function putProjectMap(id: string, request: ProjectMapRequest) {
    return await makeApiCall(
        `api/projects/${id}/project-map`, 'PUT', request
    );   
}